import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RightLinks extends Component {
  render() {
    const { s, data, handleClickQuestion } = this.props;
    return (
      <div className={s.rightLinks}>
        <div style={{ flex: 1 }}>
          <div className={s.title}>常见问题</div>
          <div className={s.docTip}>
            <ol>
              {data.slice(0, 15).map(({ title }, i) => (
                <li key={title} onClick={() => handleClickQuestion(title)}>
                  {i + 1}. {title}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

RightLinks.propTypes = {
  s: PropTypes.shape().isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};
